module.exports = __webpack_public_path__ + "img/layout-table.c411a5ad.svg";